export default "__VITE_ASSET__DqJvwdWt__"